// Scoreboard (LOOKS.md Parts 6 and 9): a stadium board at night — glowing
// numbers, LED bars, bevelled panels, condensed capitals. From its artboard,
// docs/design/mockups/looks/Scoreboard.dc.html and H2H-Scoreboard.dc.html.
// A board is lit against the dark, so it is dark in either Mode.

import { defineLook } from '../define';
import './look.css';

const NIGHT = {
  'bg-canvas': '#07080a',
  'bg-surface': '#0d1016',
  'bg-raised': '#121620',
  'bg-sunken': '#050608',
  'border-subtle': '#1d2430',
  'border-strong': '#2c3342',
  'ink-primary': '#eef0f3',
  'ink-secondary': '#a9b1bd',
  'ink-muted': '#7c8493',
  live: '#ff6b6b',
};

export default defineLook({
  id: 'scoreboard',
  label: 'Scoreboard',
  blurb: 'A stadium board at night: glowing numbers and LED bars.',
  order: 3,
  mode: 'dark',
  grounds: { dark: NIGHT, light: NIGHT },
  fonts: () =>
    Promise.all([
      import('@fontsource/barlow-condensed/500.css'),
      import('@fontsource/barlow-condensed/600.css'),
      import('@fontsource/barlow-condensed/700.css'),
      import('@fontsource/barlow-condensed/800.css'),
      import('@fontsource/orbitron/600.css'),
      import('@fontsource/orbitron/700.css'),
      import('@fontsource/orbitron/800.css'),
      import('@fontsource/orbitron/900.css'),
      import('@fontsource/share-tech-mono/400.css'),
    ]),
});
